import React, { FC } from "react";

import {
  DetailsList,
  DetailsListItem,
} from "@UI/Components/DetailsList/DetailsList";
import { FooterLink } from "./FooterLink";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "./messages";

export const FooterRightLinks: FC = () => {
  return (
    <DetailsList title={<FormattedMessage {...messages.aboutUs} />}>
      <DetailsListItem>
        <FooterLink color="gray.700" route="ABOUT" reloadDocument>
          <FormattedMessage {...messages.company} />
        </FooterLink>
      </DetailsListItem>
      <DetailsListItem>
        <FooterLink color="gray.700" route="TEAM" reloadDocument>
          <FormattedMessage {...messages.theTeam} />
        </FooterLink>
      </DetailsListItem>
      <DetailsListItem>
        <FooterLink color="gray.700" route="CAREERS" reloadDocument>
          <FormattedMessage {...messages.jobs} />
        </FooterLink>
      </DetailsListItem>
      <DetailsListItem>
        <FooterLink color="gray.700" route="PRESS" reloadDocument>
          <FormattedMessage {...messages.press} />
        </FooterLink>
      </DetailsListItem>
      <DetailsListItem>
        <FooterLink color="gray.700" route="BLOG" reloadDocument>
          <FormattedMessage {...messages.blog} />
        </FooterLink>
      </DetailsListItem>
      <DetailsListItem>
        <FooterLink color="gray.700" route="PARTNERS" reloadDocument>
          <FormattedMessage {...messages.partners} />
        </FooterLink>
      </DetailsListItem>
    </DetailsList>
  );
};
